












import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
  name: 'TimePicker',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: 'Time...',
    },

    value: {
      type: String,
      default: '',
    },
  },

  computed: {
    internalValue: {
      get(): string {
        return this.value
      },
      set(value: any): any {
        this.$emit('input', value)
      },
    },
    /**
     * Generate array of times in AM/PM format and filtered by input value
     */
    times(): Array<string> {
      const format = 'h:mma'
      const start = moment('00:00', format)
      const end = moment('23:59', format)
      const step = 15
      const times: Array<string> = []
      let currentTime = start

      while (currentTime.isSameOrBefore(end)) {
        times.push(currentTime.format(format))
        currentTime = currentTime.add(step, 'minutes')
      }

      return times
    },
  },
})
